import { AuthApi } from 'network/Auth'
import * as Thunks from './thunks'
import * as Actions from './actions'

export default class Auth extends AuthApi {
  static thunks = Thunks
  static actions = Actions
}
